// From: https://gist.github.com/jcalz/381562d282ebaa9b41217d1b31e2c211?permalink_comment_id=2618337#gistcomment-2618337

// export function tuple <T extends [void] | {}> (val: T): T {
//   return val;
// }
type Literal = string | number | boolean | undefined | null | void | {};
export const tuple = <T extends Literal[]>(...args: T) => args;